<template>
  <div v-loading="loading">
    <appeal-base-form ref="appeal-base-form" :base-params="form" :disable-fields="disableFields"></appeal-base-form>

    <status-bar :status="form.reviewStatus" class="status-bar"></status-bar>

    <notice-base-form v-if="form.bussType === LEVEL_ONE_APPEAL.CP_NOTICE.code" ref="notice-base-form" :base-params.sync="form.complaintClaim"></notice-base-form>

    <el-card class="m-t-md" header="歌单信息录入">
      <tort-complaint-add-table
        v-if="form.bussType === LEVEL_ONE_APPEAL.TORT.code"
        :data="showTrackList"
        :loading="dealing"
        @upload="handleUploadSongList"
        @save="handleSaveSongList"
      >
      </tort-complaint-add-table>
      <offline-add-table
        v-else-if="form.bussType === LEVEL_ONE_APPEAL.OFFLINE.code"
        :data="showTrackList"
        :loading="dealing"
        @upload="handleUploadSongList"
        @save="handleSaveSongList"
      >
      </offline-add-table>
      <notice-add-table
        v-else-if="form.bussType === LEVEL_ONE_APPEAL.CP_NOTICE.code"
        :data="showTrackList"
        :loading="dealing"
        @upload="handleUploadSongList"
        @save="handleSaveSongList"
      ></notice-add-table>
    </el-card>

    <el-card v-if="canEdit" class="promise-wrapper" :header="`保证声明-${appealTypeMap[form.applicationType]}`">
      <section class="promise-intro">
        <h3>保证声明</h3>
        <p>权利人及其代理人（统称为：声明人）作出如下保证：</p>
        声明人保证在通知书中的陈述和提供的相关材料皆是真实、有效和合法的，腾讯音乐有权将声明人提交的相关材料转通知给被投诉方。声明人保证承担和赔偿腾讯音乐根据声明人的通知而删除或者断开有关投诉内容而给腾讯音乐和/或被投诉方造成的任何损失，包括但不限于腾讯音乐因向被投诉方或用户赔偿而产生的损失及腾讯及其关联公司的名誉、商誉损害等。
      </section>
      <el-checkbox v-model="agreePromise" class="agree-promise">我自愿作出以上保证声明，并确保投诉内容属实</el-checkbox>
    </el-card>

    <section class="btn-group">
      <el-button v-if="isDraft" size="small" :loading="saving" @click="handleSaveDraft">保存草稿</el-button>
      <el-button
        v-if="canEdit"
        type="primary"
        size="small"
        :loading="saving"
        @click="handleSubmit"
      >
        提交
      </el-button>
    </section>
  </div>
</template>

<script>
import { Complaint, SongList, CpNotice } from '@/models/Complaint'
import complaintService from '@/api/complaint'
import AppealBaseForm from '../components/AppealBaseForm.vue'
import StatusBar from '../components/StatusBar.vue'

import TortComplaintAddTable from '../components/AddTable/TortComplaintAddTable'
import OfflineAddTable from '../components/AddTable/OfflineAddTable'
import NoticeAddTable from '../components/AddTable/NoticeAddTable'
import NoticeBaseForm from '../components/NoticeBaseForm.vue'

import {
  APPEAL_STATUS,
  LEVEL_ONE_APPEAL,
  appealTypeMap,
  levelOneAppealMap,
  levelTwoAppealMap
} from './const'

const LIMIT_FIELDS = ['applicationType', 'bussType']

export default {
  name: 'AppealEdit',
  components: {
    AppealBaseForm,
    StatusBar,
    TortComplaintAddTable,
    OfflineAddTable,
    NoticeAddTable,
    NoticeBaseForm
  },
  data() {
    return {
      LEVEL_ONE_APPEAL,
      appealTypeMap,

      loading: false,
      form: new Complaint(),
      saving: false,
      dealing: false,
      agreePromise: false,
    }
  },
  computed: {
    /**
     * @returns {Array}
     */
    showTrackList() {
      return this.form.complaintTrackList.filter(v => !v.isDel)
    },
    /**
     * @returns {Boolean}
     */
    hasTrackList() {
      return this.showTrackList.length > 0
    },
    /**
     * @returns {Array}
     */
    disableFields() {
      return this.hasTrackList ? LIMIT_FIELDS : []
    },
    /**
     * @returns {Boolean}
     */
    isDraft() {
      return this.form.reviewStatus === APPEAL_STATUS.DRAFT.code
    },
    canEdit() {
      // 草稿｜已取消｜驳回，状态下才能编辑
      return [APPEAL_STATUS.DRAFT.code, APPEAL_STATUS.CANCELEED.code, APPEAL_STATUS.REJECT.code].includes(this.form.reviewStatus)
    },
  },
  watch: {
    'form.bussType'(val) {
      if (val === LEVEL_ONE_APPEAL.CP_NOTICE.code && !this.form.complaintClaim) {
        this.form.complaintClaim = new CpNotice()
      } else if (val !== LEVEL_ONE_APPEAL.CP_NOTICE.code) {
        this.form.complaintClaim = null
      }
    }
  },
  created() {
    const id = this.$route.query.id
    if (id) {
      this.fetchData(id)
    }
  },
  methods: {
    async fetchData(id) {
      this.loading = true
      try {
        const data = await complaintService.findById(id)
        this.form = new Complaint(data)
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    },
    async handleUploadSongList(params) {
      this.dealing = true
      try {
        const { list } = await complaintService.parseCommitExcel(params)
        this.form.complaintTrackList.push(...list.map(v => new SongList({ ...v, create: true })))
      } catch (error) {
        this.$alert(`上传失败.${error.message}`, '错误', {
          error,
          type: 'error'
        })
      }
      this.dealing = false
    },
    async handleSaveSongList(data) {
      const idx = this.form.complaintTrackList.findIndex(v => v.tracklistId === data.tracklistId)
      if (idx > -1) {
        this.form.complaintTrackList.splice(idx, 1, data)
      } else {
        this.form.complaintTrackList.push(data)
      }
    },

    async handleSaveDraft() {
      const postData = {
        ...this.form.getBackendData(),
        reviewStatus: APPEAL_STATUS.DRAFT.code
      }

      try {
        const { id } = await this.saveData(postData)
        this.$message.success('保存成功')
        history.replaceState(null, null, `?id=${id}`)
        this.fetchData(id)
      } catch (error) {
        this.$alert(`保存失败.${error.message}`, '错误', {
          error,
          type: 'error'
        })
      }
    },
    async handleSubmit() {
      try {
        await this.$refs['appeal-base-form'].validate()
        if (this.$refs['notice-base-form']) {
          await this.$refs['notice-base-form'].validate()
        }
      } catch (error) {
        this.$message.error(error.message)
        return
      }

      const trackListLen = this.form.complaintTrackList.length
      if (!trackListLen) {
        this.$message.warning('请上传歌单')
        return
      }

      if (!this.agreePromise) {
        this.$message.warning('请先勾选保证声明')
        return
      }

      const postData = {
        ...this.form.getBackendData(),
        reviewStatus: APPEAL_STATUS.UNREVIEWED.code
      }

      const appealTypeName = `${appealTypeMap[postData.applicationType]}-${levelOneAppealMap[postData.bussType]}-${levelTwoAppealMap[postData.complaintType]}`
      const invalidTrackListLen = this.form.complaintTrackList.filter(v => !v.trackName && !v.albumName && !v.singerName).length
      const checkTip = invalidTrackListLen > 0 ? `<br>检测到有：<b style="color: red">${invalidTrackListLen}</b> 首作品可能存在投诉作品信息缺失，可能影响作品确权` : ''
      try {
        await this.$confirm(`本次申诉类型： <b style="color: red">${appealTypeName}</b><br>本次申诉歌单数量：<b style="color: red">${trackListLen}</b> 个${checkTip}<br>流程一经发起，无法变更，请确认提交`, '权利处理确认', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
      } catch (error) {
        return
      }

      try {
        await this.saveData(postData)
        this.$message.success('创建成功')
        this.$router.push({ name: 'outsideCpTortList' })
      } catch (error) {
        this.$alert(`创建失败.${error.message}`, '错误', {
          error,
          type: 'error'
        })
      }
    },
    async saveData(postData) {
      this.saving = true
      const data = await complaintService.save(postData).finally(() => {
        this.saving = false
      })
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.status-bar {
  margin: 16px 0;
}

.promise-wrapper {
  margin-top: 16px;

  h3 {
    margin-bottom: 12px;
  }

  .promise-intro {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #262626;
  }

  .agree-promise {
    margin-top: 20px;
    color: #8C8C8C
  }
}

.btn-group {
  margin-top: 24px;
  font-size: 16px;
  text-align: center;

  .el-button {
    width: 120px;
  }
}
</style>
